// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sheet-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 19;
}

#sheet-overlay.hidden {
  display: none;
}

#bottom-sheet {
  position: absolute;
  bottom: 0;
  left: 56px;
  right: 0;
  max-height: 50%;
  background: rgba(15, 15, 30, 0.92);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(100, 100, 160, 0.3);
  border-left: 1px solid rgba(100, 100, 160, 0.3);
  padding: 12px 16px;
  z-index: 20;
  overflow-y: auto;
  transition: transform 0.2s ease;
  font-family: system-ui, sans-serif;
  color: #ccccee;
}

#bottom-sheet.hidden {
  transform: translateY(100%);
  pointer-events: none;
}

.sheet-title {
  font-size: 13px;
  font-weight: 600;
  color: #ddddff;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(100, 100, 160, 0.2);
}

.sheet-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.sheet-label {
  font-size: 12px;
  color: #9999bb;
  min-width: 60px;
}

.sheet-select,
.sheet-input {
  flex: 1;
  padding: 5px 8px;
  border: 1px solid rgba(100, 100, 160, 0.3);
  border-radius: 4px;
  background: rgba(30, 30, 60, 0.8);
  color: #ccccee;
  font-size: 12px;
  font-family: system-ui, sans-serif;
  outline: none;
}

.sheet-select:focus,
.sheet-input:focus {
  border-color: rgba(130, 130, 200, 0.6);
}

.sheet-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #6666aa;
}

.sheet-btn {
  display: block;
  width: 100%;
  padding: 7px 0;
  margin-top: 6px;
  border: 1px solid rgba(100, 100, 160, 0.4);
  border-radius: 6px;
  background: rgba(60, 60, 120, 0.5);
  color: #ccccee;
  font-size: 12px;
  font-family: system-ui, sans-serif;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.sheet-btn:hover {
  background: rgba(80, 80, 150, 0.6);
}

.sheet-entity-list {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(100, 100, 160, 0.2);
}

.sheet-entity-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 12px;
  color: #aaaacc;
}

.sheet-btn-small {
  width: 24px;
  height: 24px;
  border: 1px solid rgba(100, 100, 160, 0.3);
  border-radius: 4px;
  background: rgba(120, 40, 40, 0.5);
  color: #ee8888;
  font-size: 12px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.sheet-btn-small:hover {
  background: rgba(150, 50, 50, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/editor/bottom-sheet.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,OAAO;EACP,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["#sheet-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 19;\n}\n\n#sheet-overlay.hidden {\n  display: none;\n}\n\n#bottom-sheet {\n  position: absolute;\n  bottom: 0;\n  left: 56px;\n  right: 0;\n  max-height: 50%;\n  background: rgba(15, 15, 30, 0.92);\n  backdrop-filter: blur(10px);\n  border-top: 1px solid rgba(100, 100, 160, 0.3);\n  border-left: 1px solid rgba(100, 100, 160, 0.3);\n  padding: 12px 16px;\n  z-index: 20;\n  overflow-y: auto;\n  transition: transform 0.2s ease;\n  font-family: system-ui, sans-serif;\n  color: #ccccee;\n}\n\n#bottom-sheet.hidden {\n  transform: translateY(100%);\n  pointer-events: none;\n}\n\n.sheet-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ddddff;\n  margin-bottom: 10px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(100, 100, 160, 0.2);\n}\n\n.sheet-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.sheet-label {\n  font-size: 12px;\n  color: #9999bb;\n  min-width: 60px;\n}\n\n.sheet-select,\n.sheet-input {\n  flex: 1;\n  padding: 5px 8px;\n  border: 1px solid rgba(100, 100, 160, 0.3);\n  border-radius: 4px;\n  background: rgba(30, 30, 60, 0.8);\n  color: #ccccee;\n  font-size: 12px;\n  font-family: system-ui, sans-serif;\n  outline: none;\n}\n\n.sheet-select:focus,\n.sheet-input:focus {\n  border-color: rgba(130, 130, 200, 0.6);\n}\n\n.sheet-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #6666aa;\n}\n\n.sheet-btn {\n  display: block;\n  width: 100%;\n  padding: 7px 0;\n  margin-top: 6px;\n  border: 1px solid rgba(100, 100, 160, 0.4);\n  border-radius: 6px;\n  background: rgba(60, 60, 120, 0.5);\n  color: #ccccee;\n  font-size: 12px;\n  font-family: system-ui, sans-serif;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.sheet-btn:hover {\n  background: rgba(80, 80, 150, 0.6);\n}\n\n.sheet-entity-list {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(100, 100, 160, 0.2);\n}\n\n.sheet-entity-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n  font-size: 12px;\n  color: #aaaacc;\n}\n\n.sheet-btn-small {\n  width: 24px;\n  height: 24px;\n  border: 1px solid rgba(100, 100, 160, 0.3);\n  border-radius: 4px;\n  background: rgba(120, 40, 40, 0.5);\n  color: #ee8888;\n  font-size: 12px;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.sheet-btn-small:hover {\n  background: rgba(150, 50, 50, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
